// extracted by mini-css-extract-plugin
module.exports = {"campaignResultsTable":"CampaignResultsTable_campaignResultsTable__2d9uZ"};